import { render, staticRenderFns } from "./TopicTag.vue?vue&type=template&id=7d315052&scoped=true"
import script from "./TopicTag.vue?vue&type=script&lang=js"
export * from "./TopicTag.vue?vue&type=script&lang=js"
import style0 from "./TopicTag.vue?vue&type=style&index=0&id=7d315052&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d315052",
  null
  
)

export default component.exports